import React, { FC, useCallback, useEffect } from 'react'
import { Card, ContractCardTitle, ContractPlanCard, ContractPlanCardBody } from 'components/Card'
import { Spacer } from 'components/Utility'
import { useDispatch, useSelector } from 'react-redux'
import { push } from 'connected-react-router'
import { FlexRow } from 'components/Flex'
import { TextButton } from 'components/Button'
import { State } from 'index'
import { fetchShopSubscriptions, retrieveInvoices, retrieveSubscriptions } from 'reducks/shopSubscription/operations'
import {
  getInvoices,
  getShopSubscriptions,
  getSubscriptions,
  getSubscriptionSchedules,
  getSubscriptionStoreRefs,
} from 'reducks/shopSubscription/selectors'
import { getShopRef } from 'reducks/store/selectors'
import { FirebaseDocRefType } from 'firebase/index'
import { ShopSubscriptionType } from 'types/shopSubscription'

const ContractPlanCardList: FC = () => {
  const dispatch = useDispatch()

  const shopRef = useSelector((state: State) => getShopRef(state))
  const shopSubscriptions = useSelector((state: State) => getShopSubscriptions(state))
  const subscriptions = useSelector((state: State) => getSubscriptions(state))
  const subscriptionSchedules = useSelector((state: State) => getSubscriptionSchedules(state))
  const subscriptionStoreRefs = useSelector((state: State) => getSubscriptionStoreRefs(state))
  const invoices = useSelector((state: State) => getInvoices(state))

  const hasValidSubscription =
    subscriptions.filter((subscription) => subscription.status !== 'canceled' && !subscription.cancel_at_period_end)
      .length > 0 ||
    subscriptionSchedules.filter((subscriptionSchedule) => subscriptionSchedule.status !== 'canceled').length > 0

  const goToInvoicePage = useCallback(() => {
    dispatch(push('/contract/invoices'))
  }, [dispatch])

  useEffect(() => {
    if (!shopRef) return
    dispatch(fetchShopSubscriptions(shopRef))
  }, [shopRef])

  useEffect(() => {
    dispatch(retrieveSubscriptions(shopSubscriptions))
  }, [shopSubscriptions])

  useEffect(() => {
    dispatch(retrieveInvoices(shopSubscriptions))
  }, [shopSubscriptions])

  return (
    <Card>
      <Spacer size={4} />
      <ContractCardTitle title={'契約中のプラン'} />
      <Spacer size={20} />
      {hasValidSubscription ? (
        <>
          {subscriptionStoreRefs.map((storeRef: FirebaseDocRefType, i) => {
            return shopSubscriptions.map((shopSubscription: ShopSubscriptionType) => {
              if (shopSubscription.store_ref.id !== storeRef.id) return
              return (
                <ContractPlanCard
                  key={storeRef.id + i.toString()}
                  isMultiSubscriptions={subscriptions.length + subscriptionSchedules.length > 1}
                  isSacriStation={shopSubscription.is_sacri_station}
                  shopSubscription={shopSubscription}
                  storeRef={storeRef}
                />
              )
            })
          })}
        </>
      ) : (
        <ContractPlanCardBody amount={null} interval={''} nextBillingDate={null} planName={null} />
      )}
      <Spacer size={20} />
      {invoices.length > 0 && (
        <FlexRow justifyContent="center">
          <TextButton label={'請求書を発行'} onClick={goToInvoicePage} />
        </FlexRow>
      )}
    </Card>
  )
}

export default ContractPlanCardList
